import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_ONORARIO_INCARICO } from '../../data.const';
import {
  retrieveOnorarioIncaricoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteOnorarioIncaricoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_ONORARIO_INCARICO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_ONORARIO_INCARICO}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        defer(() =>
          from(
            request({
              path: `onorarioIncarico`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_ONORARIO_INCARICO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveOnorarioIncaricoListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_ONORARIO_INCARICO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default deleteOnorarioIncaricoEpic;
